import React from 'react'
import {  Route, Routes } from 'react-router-dom'
import { Wedding } from './wedding'
import { Confirm } from './confirm'

export const AppRouter = () => {
    return (
      <>
     
  
  
      <Routes>
       
  
        <Route path='/' element={<Wedding/>} />
        <Route path='confirm' element={<Confirm/>} />
  
  
      </Routes>
      
      </>
    )
  }
  